const lockedCampaigns = [
  'OptInRequest',
  'MissingDetailReminder1',
  'BookingUpdated',
  'AlreadySubscribed'
]

export default lockedCampaigns
